import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';
import { domQuerySelectorAll } from 'pf-frontend-common/src/helper/dom/query-selector-all';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { BrowserDocumentService } from 'pf-frontend-common/src/service/browser-document/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { configGetKeys } from 'common/helper/config/get-keys';
import { configGetLanguage } from 'common/helper/config/get-language';
import { MapboxMapsCssFactory } from 'common/module/mapbox/maps/css.factory';
import { MapboxMapsView } from 'common/module/mapbox/maps/view';
import { HeaderService } from 'common/service/header/service';
import { StatsService } from 'common/service/stats/service';

export function MapboxMapsViewFactory(): MapboxMapsView {
  return new MapboxMapsView(
    EventEmitterFactory(),
    BrowserDocumentService(),
    HeaderService(),
    MapboxMapsCssFactory(),
    WindowService(),
    configGetKeys().mapboxMap,
    domQuerySelector,
    domQuerySelectorAll,
    StatsService(),
    configGetLanguage()
  );
}
